<script setup lang="ts">
// eslint-disable-next-line
import ActivityLog from './components/ActivityLog.vue';
</script>

<template>
  <div class="w-full">
    <ActivityLog />
  </div>
</template>
